<template>
	<v-container fluid>
		<v-row class="pa-3">
			<v-btn @click="addClick" class="ml-0" color="primary">
				<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{$t('buttons.add')}}
			</v-btn>
		</v-row>
		<v-row>
			<v-col lg="8" cols="12">
				<v-card outlined flat>
					<v-card-text>
						<DataTable
							:excel="true"
							:headers="userAccountsTable.headers"
							:items="userAccountsTable.items"
							:total="userAccountsTable.total"
							@excel="excelExport"
							@reload="reloadData"
						>
							<template #row="props">
								<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
									<td @click="editClick(props.item.id, false)">{{ props.item.username }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.user_role_display }}</td>
									<td @click="editClick(props.item.id, false)">
										<v-icon small v-if="props.item.active">fa-check</v-icon>
									</td>
									<td>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn @click="editClick(props.item.id, true)" icon v-bind="attrs" v-on="on">
												<v-icon small>fa-external-link-alt</v-icon>
											</v-btn>
											</template>
											<span>{{$t('tooltips.openInNewTab')}}</span>
										</v-tooltip>
									</td>
								</tr>
							</template>
						</DataTable>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";

export default {
	name: "UserAccounts",
	components: {DataTable},
	data: function () {
		return {
			userAccountsTable: {
				headers: [
					{text: this.$t('fields.username'), value: 'username', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.role'), value: 'user_role_id', type: 'dropdown_ajax|user-roles', searchable: false},
					{text: this.$t('fields.active'), value: 'active', type: 'boolean_yes', width: "100px", searchable: 'hidden'},
					{text: '', value: 'actions', type: '', sortable: false, align: "right", width: "100px", searchable: false}
				],
				items: [],
				total: 0,
				lastRequest: null
			},

		}
	},
	methods: {
		addClick() {
			this.$router.push('/user-accounts/0')
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/user-accounts/' + id)
			} else {
				let routeData = this.$router.resolve('/user-accounts/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'users', request, (data, success) => {
				if (success) {
					vm.userAccountsTable.items = data.items;
					vm.userAccountsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'users', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/users', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.userAccounts'), href: '/#/user-accounts', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
